<!--
<div class="contains">
  <label for="cname">Contains</label>
  <div class="select-container">
    <input type="checkbox" id="contains" name="contains" value="1">
  </div>
</div>
-->
<div class="contains">
  <!--<label for="cname">Search Type</label>-->
  <label>
    Search Type <img id="ttimg" src="images/tooltip.png" height="16" width="12" />
  </label>
  <dx-tooltip target="#ttimg"
              showEvent="dxhoverstart"
              hideEvent="dxhoverend">
    <div *dxTemplate="let data of 'content'">
      <p>Over the years, names were indexed differently.  To view all differences,<br />
         view the Contains Search.  Contains search shows any occurrence of the last name<br />
         and first name whereever in the database.  Scroll down the list to see variations.<p>
    </div>
  </dx-tooltip>
  <div class="select-container">
    <select class="select" name="contains" [(ngModel)]="utilityobj.contains">
      <option value="0" selected>Begins With</option>
      <option value="1">Contains</option>
    </select>
  </div>
</div>


